import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { StaffService } from "..";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { StaffInsertModel } from "../shared/StaffInsertModel";
import * as moment from "moment";

@Component({
	selector: "app-edit-staff",
	templateUrl: "./edit-staff.component.html",
	styleUrls: ["./edit-staff.component.css"],
})
export class EditStaffComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private staffService: StaffService,
		private userService: UserService,
		private schoolService: SchoolService
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.PersonID = this.dialogConfig.data.PersonID;

		this.LoadPersonData();

		//Load data
		this.user = this.userService.getCurrentUser();

		// this.loadSchools();
		// this.loadStaffType();
		// this.loadEthnicity();
	}

	//////////////////////////////////////
	// Data
	//////////////////////////////////////

	DefinedByID: any = 1;
	EnableStaffEmail: any = -1;

	//Edit
	PersonID: any;
	StaffRawData: any;

	user: any;
	SchoolID: any;
	lstSchool: any = [];
	AllowStaffChangeSchools: boolean = false;

	//Form data
	FirstName: any = "";
	MInitial: any = "";
	LastName: any = "";
	Title: any = "";
	DOB: any = new Date();

	Gender: any = "N";
	lstGender: any = [
		{
			ID: "N",
			Desc: "Not Specified",
		},
		{
			ID: "F",
			Desc: "F",
		},
		{
			ID: "M",
			Desc: "M",
		},
	];

	StaffID: any = "";
	OriginalStaffID: any = "";

	StaffType: any;
	lstStaffType: any = [];

	SSN: any = "";

	Ethnicity: any;
	lstEthnicity: any = [];

	Status: any = 1;
	lstStatus: any = [
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	Address1: any = "";
	Address2: any = "";
	City: any = "";
	State: any = "";
	Zip: any = "";
	WPhone: any = "";
	CPhone: any = "";
	HPhone: any = "";
	Fax: any = "";
	Email: any = "";

	errorMessage: any = "";

	//////////////////////////////////////

	//////////////////////////////////////
	// Load Data
	//////////////////////////////////////

	LoadPersonData() {
		var result = this.staffService.StaffGetData(this.PersonID);
		result.subscribe(
			(response) => {
				this.StaffRawData = response[0];

				this.UpdateData();
			},
			(error) => {}
		);
	}

	UpdateData() {
		this.DefinedByID = this.StaffRawData.DefinedByID;
		this.EnableStaffEmail = this.StaffRawData.EnableStaffEmail;
		this.AllowStaffChangeSchools = this.StaffRawData.AllowStaffChangeSchools;

		this.SchoolID = this.StaffRawData.SchoolID;
		this.FirstName = this.StaffRawData.FirstName != undefined ? this.StaffRawData.FirstName : "";
		this.MInitial = this.StaffRawData.MiddleInitial != undefined ? this.StaffRawData.MiddleInitial : "";
		this.LastName = this.StaffRawData.LastName != undefined ? this.StaffRawData.LastName : "";
		this.Title = this.StaffRawData.StaffTitle != undefined ? this.StaffRawData.StaffTitle : "";
		this.DOB = this.StaffRawData.DOB != undefined && new Date(this.StaffRawData.DOB).getFullYear() >= 1900 ? new Date(this.StaffRawData.DOB) : null;
		this.Gender = this.StaffRawData.Gender != undefined ? this.StaffRawData.Gender : "";

		this.StaffID = this.StaffRawData.StaffID != undefined ? this.StaffRawData.StaffID : "";
		this.OriginalStaffID = this.StaffRawData.StaffID != undefined ? this.StaffRawData.StaffID : "";

		this.StaffType = this.StaffRawData.PersonTypeID != undefined ? this.StaffRawData.PersonTypeID : "";
		this.SSN = this.StaffRawData.SSN != undefined ? this.StaffRawData.SSN : "";
		this.Ethnicity = this.StaffRawData.Ethnicity != undefined ? this.StaffRawData.Ethnicity : "";
		this.Status = this.StaffRawData.Active != undefined ? Number(this.StaffRawData.Active) : 0;
		this.Address1 = this.StaffRawData.Street1 != undefined ? this.StaffRawData.Street1 : "";
		this.Address2 = this.StaffRawData.Street2 != undefined ? this.StaffRawData.Street2 : "";
		this.City = this.StaffRawData.City != undefined ? this.StaffRawData.City : "";
		this.State = this.StaffRawData.State != undefined ? this.StaffRawData.State : "";
		this.Zip = this.StaffRawData.Zip != undefined ? this.StaffRawData.Zip : "";
		this.WPhone = this.StaffRawData.WorkPhone != undefined ? this.StaffRawData.WorkPhone : "";
		this.CPhone = this.StaffRawData.CellPhone != undefined ? this.StaffRawData.CellPhone : "";
		this.HPhone = this.StaffRawData.HomePhone != undefined ? this.StaffRawData.HomePhone : "";
		this.Fax = this.StaffRawData.FaxNumber != undefined ? this.StaffRawData.FaxNumber : "";
		this.Email = this.StaffRawData.EMail != undefined ? this.StaffRawData.EMail : "";

		this.loadSchools();
	}

	loadSchools() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				//this.SchoolID = this.lstSchool[0].SchoolID;

				this.loadStaffType();
			},
			(error) => {}
		);
	}

	loadStaffType() {
		var result = this.staffService.StaffTypeSelectList();
		result.subscribe(
			(response) => {
				this.lstStaffType = response;
				//this.StaffType = this.lstStaffType[0].PersonTypeID;

				this.loadEthnicity();
			},
			(error) => {}
		);
	}

	loadEthnicity() {
		var result = this.staffService.EthnicitySelectList();
		result.subscribe(
			(response) => {
				this.lstEthnicity = response;
				//this.Ethnicity = this.lstEthnicity[0].EthnicityID;
			},
			(error) => {}
		);
	}
	//////////////////////////////////////

	//////////////////////////////////////
	// Buttons
	//////////////////////////////////////
	onUpdate() {
		this.errorMessage = "";

		////////////////////////////////////
		// Error handling
		////////////////////////////////////

		//Format (phone, fax, etc.)

		//ID in use

		this.CheckBlanks();

		////////////////////////////////////

		//Add Data
		// this.FinishAdd();
	}

	CheckBlanks() {
		if (this.FirstName == "") {
			this.errorMessage = "Enter a first name";
			return;
		}

		if (this.LastName == "") {
			this.errorMessage = "Enter a last name";
			return;
		}

		// if(this.Title == ""){
		//   this.errorMessage = "Enter a job title";
		//   return;
		// }

		if (this.StaffID == "") {
			this.errorMessage = "Enter a staff ID";
			return;
		}

		this.CheckFormat();
	}

	ReplaceAllOccur(Mainstr: string, findStr: string, replaceStr: string) {
		let ans = String(Mainstr);
		while (ans.indexOf(findStr) != -1) {
			ans = ans.replace(findStr, replaceStr);
		}

		return ans;
	}

	CheckFormat() {
		//Update phone numbers
		this.WPhone = this.ReplaceAllOccur(String(this.WPhone), "-", "");
		this.HPhone = this.ReplaceAllOccur(String(this.HPhone), "-", "");
		this.CPhone = this.ReplaceAllOccur(String(this.CPhone), "-", "");
		this.Zip = this.ReplaceAllOccur(String(this.Zip), "-", "");

		//Length = 10, no letters

		if (this.WPhone != "" && (this.WPhone.length != 10 || this.ContainsLetters(this.WPhone))) {
			this.errorMessage = "Invalid Work Phone number. System expects ###-###-#### format";
			return;
		}

		if (this.HPhone != "" && (this.HPhone.length != 10 || this.ContainsLetters(this.HPhone))) {
			this.errorMessage = "Invalid Home Phone number. System expects ###-###-#### format";
			return;
		}

		if (this.CPhone != "" && (this.CPhone.length != 10 || this.ContainsLetters(this.CPhone))) {
			this.errorMessage = "Invalid Cell Phone number. System expects ###-###-#### format";
			return;
		}

		if (this.Zip != "" && !this.ValidZip(this.Zip)) {
			this.errorMessage = "Invalid Zip Code. System expects ##### or #####-#### format";
			return;
		}

		//Social Security

		this.CheckStaffID();
	}

	ValidZip(zip) {
		if (this.ContainsLetters(zip)) {
			return false;
		}

		if (zip.length != 5 && zip.length != 9) {
			return false;
		}

		return true;
	}

	ContainsLetters(str) {
		if (str == undefined) {
			return true; //Throw error
		}

		for (var i = 0; i < str.length; i++) {
			var nextChar = String(str).substring(i, i + 1);

			if (isNaN(Number(nextChar))) {
				return true;
			}
		}

		return false;
	}

	CheckStaffID() {
		// Edit mode, don't check staff ID if it hasn't changed
		// It will already be in DB
		if (String(this.StaffID) == String(this.OriginalStaffID)) {
			this.FinishUpdate();
		} else {
			var result = this.staffService.StaffIDInUse(this.StaffID);
			result.subscribe(
				(response) => {
					if (response) {
						this.errorMessage = "Staff ID already in use";
						return;
					} else {
						this.FinishUpdate();
					}
				},
				(error) => {}
			);
		}
	}

	FinishUpdate() {
		// var DefinedBy: any = this.user.UserLevelID == 1 ? 4 : 3;

		var DateOfBirth: any = "";
		if (this.DOB == null) {
			DateOfBirth = "-1";
		} else {
			DateOfBirth = moment(this.DOB).format("MM/DD/YYYY");
		}

		//Create Parms
		let parms: StaffInsertModel = {
			PersonID: this.PersonID,
			LastName: this.LastName,
			FirstName: this.FirstName,
			MiddleInitial: this.MInitial,
			StaffTitle: this.Title,
			StaffID: this.StaffID,
			PersonTypeID: this.StaffType,
			EMail: this.Email, // Added?
			SSN: this.SSN,
			Gender: this.Gender,
			DOB: DateOfBirth, //moment.format
			Street1: this.Address1,
			Street2: this.Address2,
			City: this.City,
			State: this.State,
			Zip: this.Zip,
			HomePhone: this.HPhone,
			CellPhone: this.CPhone,
			WorkPhone: this.WPhone,
			FaxNumber: this.Fax,
			Pager: "", //No longer used?
			Ethnicity: this.Ethnicity,
			Active: this.Status,
			SchoolID: this.SchoolID,
			RaceID: -1, //Not used?
			DefinedByID: this.DefinedByID,
		};

		var result = this.staffService.StaffUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Staff member was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not update the staff member",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////

	//////////////////////////////////////
	// Helpers
	//////////////////////////////////////
	EnableSchoolChange() {
		// return false;
		return this.EnableEdit() == true && (this.user.userID == 0 || this.AllowStaffChangeSchools == true);
		// return this.user.userID == 0;
	}

	EnableEdit() {
		if (this.DefinedByID <= 2) {
			return false;
		}
		// else if (this.user.UserLevelID == 3 && this.DefinedByID == 4) {
		// 	return false;
		// }

		return true;
	}

	EnableEditEmail() {
		return this.EnableEdit() || this.EnableStaffEmail == 0;
	}

	//////////////////////////////////////
}
